/*                                      */

/**
 *
 *
 */
export const VERSION = '5.41.4';
export const PUBLIC_VERSION = '5';
